import { DataBean } from "../../DataBean";


export class ProvisionCatalogData extends DataBean {

    public async createProvisions(year: any, month: any, idLoggedEmployee: any, recalculateProvisions: any, adjustAccountantBook: any, vacationDays: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_createProvisions_Number_Number_Number_Boolean_Boolean_Number", [year, month, idLoggedEmployee, recalculateProvisions, adjustAccountantBook, vacationDays]);
    }

}